import React, { useState, useEffect } from "react";
import { Edit, Trash2, Plus, RotateCcw } from "lucide-react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { toast } from "react-toastify";
import "./Zone.css";

const url = process.env.REACT_APP_BACKEND_URL;

const ZoneList = () => {
  const [zones, setZones] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showInactive, setShowInactive] = useState(false);
  const navigate = useNavigate();

  const fetchZones = async () => {
    try {
      setLoading(true);
      const endpoint = showInactive ? `${url}/api/zone/all` : `${url}/api/zone`;
      const res = await axios.get(endpoint);
      setZones(res.data.data || []);
    } catch (err) {
      toast.error(err.response?.data?.message || "Failed to fetch zones");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchZones();
  }, [showInactive]);

  const handleSoftDelete = async (id) => {
    if (window.confirm("Are you sure you want to deactivate this zone?")) {
      try {
        const res = await axios.delete(`${url}/api/zone/${id}`);
        toast.success(res.data.message || "Zone deactivated successfully");
        fetchZones();
      } catch (err) {
        toast.error(err.response?.data?.message || "Failed to deactivate zone");
      }
    }
  };

  const handleRestore = async (id) => {
    if (window.confirm("Are you sure you want to activate this zone?")) {
      try {
        const res = await axios.put(`${url}/api/zone/${id}/restore`);
        toast.success(res.data.message || "Zone activated successfully");
        fetchZones();
      } catch (err) {
        toast.error(err.response?.data?.message || "Failed to activate zone");
      }
    }
  };

  if (loading) return <div className="loading">Loading zones...</div>;

  return (
    <div className="district-container">
      <div className="header">
        <h2>Zones List</h2>
        <div className="header-actions">
          <button
            onClick={() => setShowInactive(!showInactive)}
            className={`toggle-button ${showInactive ? 'active' : ''}`}
          >
            {showInactive ? 'Showing All' : 'Show Active Only'}
          </button>
          <button
            onClick={() => navigate("/AddZone")}
            className="add-button"
          >
            <Plus size={16} /> Add Zone
          </button>
        </div>
      </div>

      <div className="district-list">
        <table>
          <thead>
            <tr>
              <th>Name</th>
              <th>Status</th>
              <th style={{ textAlign: "center", width: "150px" }}>Actions</th>
            </tr>
          </thead>
          <tbody>
            {zones.length === 0 ? (
              <tr>
                <td colSpan="3" className="no-data">
                  No zones found
                </td>
              </tr>
            ) : (
              zones.map((zone) => (
                <tr key={zone._id} className={zone.status === 'inactive' ? 'inactive-row' : ''}>
                  <td>{zone.name}</td>
                  <td>
                    <span className={`status-badge ${zone.status}`}>
                      {zone.status === 'active' ? 'Active' : 'Inactive'}
                    </span>
                  </td>
                  <td>
                    <div className="actions">
                      {zone.status === 'active' ? (
                        <>
                          <button
                            onClick={() => navigate(`/zone/edit/${zone._id}`)}
                            className="edit"
                            title="Edit"
                          >
                            <Edit size={16} />
                          </button>
                          <button
                            onClick={() => handleSoftDelete(zone._id)}
                            className="delete"
                            title="Deactivate"
                          >
                            <Trash2 size={16} />
                          </button>
                        </>
                      ) : (
                        <button
                          onClick={() => handleRestore(zone._id)}
                          className="restore-btn"
                          title="Activate"
                        >
                          <RotateCcw size={16} /> Activate
                        </button>
                      )}
                    </div>
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default ZoneList;